<script setup lang="ts">
withDefaults(defineProps<{
  title?: string
  text?: string
  full?: boolean
}>(), {
  title: 'Секунду…',
  text: '',
  full: false,
})
</script>

<template>
  <div class="loading-state" :class="{ 'loading-state--full': full }">
    <span class="loader" aria-hidden="true"></span>
    <div>
      <strong>{{ title }}</strong>
      <p v-if="text">{{ text }}</p>
    </div>
  </div>
</template>
